// Sesión caducada: si el backend rechaza el token que tenemos guardado
// («Token Expired!» / «Auth failed!»), se borra la sesión local y se manda a
// iniciar sesión, volviendo luego a la misma página. Antes la cabecera seguía
// mostrando a la persona conectada y páginas como Mis viajes salían vacías.
import { BASEURL } from "../api";
import axios from "axios";
import { routes } from "../routesConfig";

const SESSION_KEYS = ["token", "googletoken", "email", "image"];
const EXPIRED = ["Token Expired!", "Auth failed!"];

function authHeader(headers) {
  if (!headers) return "";
  if (typeof headers.get === "function") return headers.get("Authorization") || "";
  return headers.Authorization || headers.authorization || "";
}

let handled = false;

// true si la petición iba al backend con el token guardado y este se rechazó
function rejectsStoredToken(url, sentAuth, message) {
  const token = localStorage.getItem("token") || localStorage.getItem("googletoken");
  return (
    String(url || "").startsWith(BASEURL) &&
    !!token &&
    sentAuth === `Bearer ${token}` &&
    EXPIRED.includes(message)
  );
}

function endSession() {
  if (handled) return;
  handled = true;
  SESSION_KEYS.forEach((k) => localStorage.removeItem(k));
  const lang = window.location.pathname.startsWith("/en") ? "en" : "es";
  const next = window.location.pathname + window.location.search;
  window.location.assign(`${routes[lang].login}?next=${encodeURIComponent(next)}`);
}

export function installSessionGuard() {
  if (typeof window === "undefined" || window.__ttSessionGuard) return;
  window.__ttSessionGuard = true;
  const original = window.fetch.bind(window);

  axios.interceptors.response.use(undefined, (error) => {
    const r = error?.response;
    try {
      if (r?.status === 401) {
        const cfg = error.config || {};
        const sent = authHeader(cfg.headers);
        const url = cfg.url?.startsWith("http") ? cfg.url : `${cfg.baseURL || ""}${cfg.url || ""}`;
        if (rejectsStoredToken(url, sent, r.data?.message)) endSession();
      }
    } catch (e) {}
    return Promise.reject(error);
  });

  window.fetch = async (input, init) => {
    const res = await original(input, init);
    if (res.status !== 401 || handled) return res;
    try {
      const url = typeof input === "string" ? input : input?.url || "";
      const sent = authHeader(init?.headers) || authHeader(input?.headers);
      if (!String(url).startsWith(BASEURL) || !sent) return res;
      const body = await res.clone().json().catch(() => null);
      if (rejectsStoredToken(url, sent, body?.message)) endSession();
    } catch (e) {}
    return res;
  };
}
